import { useNavigate } from 'react-router-dom';

import { useAppContext } from '../../../app/Context';
import { logout } from '../../../db/auth';
import routes from '../../../routes/router';

const useHeader = () => {
  const navigate = useNavigate();

  const { setSession } = useAppContext();

  const handleLogout = async () => {
    await logout();
    setSession(null);
    navigate(routes.auth.url(), { replace: true });
  };

  return { handleLogout };
};

export default useHeader;
